import React, { useEffect, useState, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

const AnswerExplanation = (props) => {
  const {
    explanationVisible,
    explanationStatus,
    explanationText,
    onExplanationClosed
  } = props

  const [displayModal, setDisplayModal] = useState(false)

  useEffect(() => {
    if (explanationVisible) {
      setDisplayModal(true)
    } else {
      setDisplayModal(false)
    }
  }, [explanationVisible])

  const handleExplanation = () => {
    setDisplayModal(false)
    onExplanationClosed()
  }

  if (explanationVisible) {
    return (
      <Modal show={displayModal} onHide={handleExplanation} centered={true}>
        <Modal.Header
          closeButton
          className={
            explanationStatus
              ? 'model_explanation_heading_correct'
              : 'model_explanation_heading_wrong'
          }
        >
          <Modal.Title className='model_title_name_explanation'>
            {' '}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {explanationStatus ? (
                <CheckCircleOutlineIcon
                  style={{
                    width: '50px',
                    height: '50px',
                    color: '#0bff31',
                    textAlign: 'center'
                  }}
                />
              ) : (
                <HighlightOffIcon
                  style={{
                    width: '50px',
                    height: '50px',
                    color: '#ff4230',
                    textAlign: 'center'
                  }}
                />
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row model_heading_row'>
            <textarea
              className='form-control-textarea_explanation'
              defaultValue={explanationText}
              rows='4'
              id='comment'
              placeholder='Please show detailed steps.'
              readOnly={true}
              style={{ resize: 'none' }}
            />
          </div>
        </Modal.Body>
      </Modal>
    )
  }
  return null
}

export { AnswerExplanation }
